import React from 'react';
import { getLabel } from '../../data/labels';

export default function BonusApplied(props) {
    const bonusData = props.bonusData;
    const appliedData = props.appliedData;

    const descPart1 = getLabel('betslip_alt.bonus_applied.add_more_selections.part1').replace(/{{MIN_ODD}}/g, bonusData.minimumOdd / 100) ?? '';
    const descPart2 = getLabel('betslip_alt.bonus_applied.add_more_selections.part2').replace(/{{PERCENTAGE}}/g, bonusData.reachingPercentage) ?? '';

    return (
        <div className="cartEvent cartEvent--bonus">
            <div className="cartEvent__header">
                <div className="cartEvent__title">
                    <div className="cartEvent__title__icon cartEvent__title"></div>
                    {appliedData.description}
                </div>
                <div className="cartEvent__header__controls">
                    <div className="cartEvent__header__control cartEvent__header__control--info"></div>
                </div>
            </div>
            <div className="cartEvent__body">
                <div className="cartEvent__body__title">
                    <div className="cartEvent__body__titleBadge">{appliedData.appliedPercentage * 100}%</div>
                    <span>{getLabel('betslip_alt.bonus_applied')}</span>
                </div>
                <div className="cartEvent__body__content">
                    <div className="cartEvent__body__text">
                        {descPart1}
                        <span className="cartEvent__body__text cartEvent__body__text--highlight">{descPart2}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
